import { useCallback, useEffect, useState } from "react";
import { useVideoPlayerRefs } from "../contexts/VideoPlayerRefs";

export type Buffer = {
  start: number;
  end: number;
};

const useBuffers = (seekBarWidth: number): Buffer[] => {
  const [buffers, setBuffers] = useState<Buffer[]>([]);
  const { video } = useVideoPlayerRefs();

  const handler = useCallback(() => {
    if (video.current !== null) {
      const { buffered, duration } = video.current;

      const getPosition = (time: number) => (time / duration) * seekBarWidth;

      if (buffered.length > 0) {
        const newBuffers = [];

        for (let i = 0; i < buffered.length; i += 1) {
          newBuffers.push({
            start: getPosition(buffered.start(i)),
            end: getPosition(buffered.end(i)),
          });
        }

        setBuffers(newBuffers);
      }
    } else {
      setBuffers([]);
    }
  }, [seekBarWidth, video]);

  /**
   * Responds to buffering events to update the buffer bar
   */
  useEffect(() => {
    if (video.current !== null) {
      const element = video.current;
      element.addEventListener("progress", handler);
      handler();

      return () => {
        element.removeEventListener("progress", handler);
      };
    }

    return undefined;
  }, [handler, video]);

  return buffers;
};

export default useBuffers;
